
//
const serviceButton = document.querySelector('.service-button[data-service="bunk-portfolio"]')

//
if (serviceButton !== null) {

    //
    const zenoFetch     = require('../utils/zenoFetch.js');
    const createElement = require('../utils/createElement.js');

    //toggle the information panel as needed
    serviceButton.addEventListener('click', function(event) {
        if (event.target.matches('[data-action="toggle-service-information"]') == true) {
            event.target.closest('.service-button').setAttribute('data-show-service-information', ((serviceButton.dataset.showServiceInformation == 'no') ? 'yes' : 'no'));
        }
    });

    //if this is the first time using the service, you must agree that you are using the service for your own properties
    if (serviceButton.querySelector('input[name="agreeBunkPortfolioTermsAndConditions"]') !== null) {
        serviceButton.querySelector('input[name="agreeBunkPortfolioTermsAndConditions"]').addEventListener('change', function(event) {
            serviceButton.querySelector('button[data-action="open-bunk-portfolio"]').disabled = !event.target.checked;
        });
    }

    //
    const setLoadingState = function(state) {
        if ((button = serviceButton.querySelector('button[data-action="open-bunk-portfolio"]')) !== null) {
            button.toggleAttribute('data-loading', state);
            button.disabled = state;
        }
    }

    //
    const setErrorMessage = function(message) {

        //
        serviceButton.classList.toggle('service-button-error', (message !== null));

        //
        if (message === null && (serviceButtonButtonErrorMessage = serviceButton.querySelector('.service-button-button p[data-name="error-message"]'))) {
            serviceButtonButtonErrorMessage.remove();
        }

        //
        if (message !== null) {
            const serviceButtonButtonContainer = serviceButton.querySelector('.service-button-button');
            serviceButtonButtonContainer.insertAdjacentElement('beforeend', createElement('p', { 'data-name' : 'error-message' }, message));
        }

    }

    //
    serviceButton.addEventListener('click', async function(event) {

        //use event delegation to only deal with the "continue" button when it's not been disabled
        if (!event.target.matches('button[data-action="open-bunk-portfolio"]:not(:disabled)')) {
            return;
        }

        //
        event.preventDefault();

        //
        setLoadingState(true);
        setErrorMessage(null);

        //
        const [status, message] = await zenoFetch('post', '/api/get-bunk-portfolio-auth-token');

        //
        if (status == 'success') {
            window.location = '/portfolio/';
            return;
        }

        //
        setLoadingState(false);
        setErrorMessage(message);

    });

}